<template>
  <v-dialog
    v-model="dialog"
    width="600"
    @click:outside="cancel"
  >
    <v-card light>
      <v-btn
        class="float-right"
        icon
        @click="cancel"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title class="px-8 pt-12"> Add Trait </v-card-title>
      <v-card-text class="px-8">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="trait.categoryId"
                outlined
                label="Categories"
                :items="categoriesToDisplay"
                validate-on-blur
                hide-details="auto"
                item-value="id"
                item-text="name"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="trait.text"
                outlined
                label="Text"
                :rules="[$rules.required]"
                maxlength="500"
                validate-on-blur
                hide-details="auto"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                x-large
                :loading="saving"
                color="primary"
                @click="save"
              >
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {},
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    trait: {}
  }),
  computed: {
    categoriesToDisplay() {
      return [{ id: null, name: '*** Base ***' }].concat(this.categories);
    },
    ...mapGetters({
      categories: 'lookup/categories'
    })
  },
  mounted() {
    if (!this.categories.length) {
      this.$store.dispatch('lookup/getCategories');
    }
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    showDialog(materialId, categoryId) {
      this.dialog = true;
      this.trait = { materialId, categoryId: categoryId || null, text: '' };
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch('print/saveMaterialTrait', this.trait)
          .then(() => {
            this.$emit('save');
            this.$refs.form.reset();
            this.dialog = false;
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
